import { memo } from "react";
import { useTranslation } from "react-i18next";
import ContactForm from "./ContactForm";

function ContactUs() {
  const { t } = useTranslation();
  return (
    <main
      className="page-content contact-us-page p-4 pt-5 pt-md-5 m-0"
      aria-label={t("contact.pageAria")}
    >
      <ContactForm />
    </main>
  );
}

ContactUs.displayName = "ContactUs";

export default memo(ContactUs);
